import * as React from 'react';
import { FeatureFlag } from 'react-launch-darkly';

interface FeatureToggleProps {
    flag: string;
    children?: any;
}

export class FeatureToggle extends React.Component<FeatureToggleProps> {
    constructor(props: FeatureToggleProps) {
        super(props);
        this.renderFeature = this.renderFeature.bind(this);
    }
    public renderFeature() {
        return this.props.children;
    }

    public render() {
        const { flag } = this.props;
        return(
            <FeatureFlag
                flagKey={flag}
                renderFeatureCallback={this.renderFeature}
            />);
    }
}
